import { render, staticRenderFns } from "./Background.html?vue&type=template&id=0a3d0cd4&scoped=true&"
import script from "./Background.js?vue&type=script&lang=js&"
export * from "./Background.js?vue&type=script&lang=js&"
import style0 from "./Background.scss?vue&type=style&index=0&id=0a3d0cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d0cd4",
  null
  
)

component.options.__file = "Background.vue"
export default component.exports